import _classCallCheck from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/oleksiim/projects/wix/playable/node_modules/okidoc-site/site/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import NavButton from './NavButton';
import NavigationHeadings from './NavigationHeadings';
import NavigationItems from './NavigationItems';
import classNames from 'classnames';

var Navigation =
/*#__PURE__*/
function (_Component) {
  _inherits(Navigation, _Component);

  function Navigation(props) {
    var _this;

    _classCallCheck(this, Navigation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Navigation).call(this, props));
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(Navigation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          headings = _this$props.headings,
          navigation = _this$props.navigation,
          isSinglenavigationItem = _this$props.isSinglenavigationItem;
      var isOpen = this.state.isOpen;
      return React.createElement(Fragment, null, React.createElement(NavButton, {
        isOpen: isOpen,
        onClick: function onClick() {
          _this2.setState(function (_ref) {
            var isOpen = _ref.isOpen;
            return {
              isOpen: !isOpen
            };
          });
        }
      }), React.createElement("div", {
        className: classNames('toc-wrapper', {
          open: isOpen,
          single: isSinglenavigationItem
        })
      }, navigation && navigation.length > 0 && React.createElement("div", {
        className: "toc-footer"
      }, React.createElement(NavigationItems, {
        items: navigation
      })), headings.length > 1 && React.createElement(NavigationHeadings, {
        headings: headings
      })));
    }
  }]);

  return Navigation;
}(Component);

Navigation.propTypes = {
  headings: PropTypes.any.isRequired,
  navigation: PropTypes.array.isRequired
};
export default Navigation;